// extracted by mini-css-extract-plugin
export default {"ticker":"Ticker_ticker__Pek-Y","track":"Ticker_track__8Pnub","list":"Ticker_list__8SI9P","item":"Ticker_item__0s3xs"};